import { put, takeLatest } from "redux-saga/effects";
import {
  LOGIN,
  LOGIN_FAILED,
  LOGIN_INIT,
  LOGIN_SUCCESS,
  TWO_FACTOR_AUTH,
  TWO_FACTOR_AUTH_INIT,
  TWO_FACTOR_AUTH_SUCCESS,
  TWO_FACTOR_AUTH_FAILED,
  VERIFY_PHONE,
  VERIFY_PHONE_INIT,
  VERIFY_PHONE_SUCCESS,
  VERIFY_PHONE_FAILED,
  TERMS_AND_CONDITION,
  TERMS_AND_CONDITION_INIT,
  TERMS_AND_CONDITION_SUCCESS,
  TERMS_AND_CONDITION_FAILED,
  SEND_TWO_FA_CODE,
  SEND_TWO_FA_CODE_INIT,
  SEND_TWO_FA_CODE_SUCCESS,
  SEND_TWO_FA_CODE_FAILED,
  SEND_TWO_FA_CODE_TO_EMAIL_INIT,
  SEND_TWO_FA_CODE_TO_EMAIL_SUCCESS,
  SEND_TWO_FA_CODE_TO_EMAIL_FAILED,
  SEND_TWO_FA_CODE_TO_EMAIL,
} from "./constants";
import {
  postUtil,
  setBearerToken,
  setDefaultHeader,
} from "../../../services/axiosClient";
import jwt_decode from "jwt-decode";
import { API, setStorageItem } from "../../../utils/Constant";

const changeToBoolean = (value) => {
  return value === "true" ? true : false;
};

export function* loginCall({ payload, callback }) {
  yield put({ type: LOGIN_INIT });
  try {
    const res = yield postUtil(API.Login, payload);
    if (res?.status === 200) {
      const { data } = res;
      const user = jwt_decode(data.result.accessToken);
      let redirect = 0;
      let { IsTwoFactorEnable, PhoneVerified, Signed } = user;
      IsTwoFactorEnable = changeToBoolean(IsTwoFactorEnable);
      PhoneVerified = changeToBoolean(PhoneVerified);
      Signed = changeToBoolean(Signed);

      if (!PhoneVerified && IsTwoFactorEnable) {
        redirect = 1;
      }

      if (PhoneVerified && IsTwoFactorEnable) {
        redirect = 3;
      }

      if (PhoneVerified && !IsTwoFactorEnable && !Signed) {
        redirect = 2;
      }
      if (!PhoneVerified && !IsTwoFactorEnable) {
        redirect = 1;
      }

      if (user.PhoneVerified === "false") {
        yield put({
          ...user,
          type: LOGIN_SUCCESS,
          Signed,
          token: data.result.accessToken,
          IsTwoFactorEnable: user.IsTwoFactorEnable,
          PhoneVerified: user.PhoneVerified,
          redirect,
          userId: data.result.userId,
          PhoneNumber : user.PhoneNumber,
        });
      } else if (user.IsTwoFactorEnable === "true") {
        yield put({
          ...user,
          type: LOGIN_SUCCESS,
          Signed,
          IsTwoFactorEnable: user.IsTwoFactorEnable,
          token: data.result.accessToken,
          PhoneVerified: user.PhoneVerified,
          redirect,
          userId: data.result.userId,
          PhoneNumber : user.PhoneNumber,
        });
      } else if (user.Signed === "false") {
        yield put({
          ...user,
          type: LOGIN_SUCCESS,
          Signed,
          IsTwoFactorEnable: user.IsTwoFactorEnable,
          PhoneVerified: user.PhoneVerified,
          token: data.result.accessToken,
          redirect,
          userId: data.result.userId,
          PhoneNumber : user.PhoneNumber,
        });
      } else {
        setStorageItem(localStorage, "token", data.result.accessToken, () => {
          callback();
        });
      }
    } else {
      yield put({ type: LOGIN_FAILED,res });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* twoFactor({ payload, onSuccess }) {
  const { code } = payload;
  const twoFactorCode = {
    code: code,
  };
  setBearerToken(payload.token);
  yield put({ type: TWO_FACTOR_AUTH_INIT });
  try {
    const res = yield postUtil(`${API.TwoFactor}`, twoFactorCode);
    if (res?.status === 200) {
      const { data } = res;
      setStorageItem(localStorage, "token", data.result.accessToken, () => {
        setDefaultHeader();
        if (payload.signed) {
          onSuccess();
        }
      });
      yield put({
        type: TWO_FACTOR_AUTH_SUCCESS,
        onSuccess,
        token: data.result.accessToken,
      });
    } else {
      yield put({ type: TWO_FACTOR_AUTH_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* verifyPhone({ payload }) {
  const { code, token, onSuccess } = payload;
  const verifyPhoneCode = {
    code: code,
  };
  setBearerToken(token);
  yield put({ type: VERIFY_PHONE_INIT });
  try {
    const res = yield postUtil(`${API.VerifyPhone}`, verifyPhoneCode);
    if (res?.status === 200) {
      const { data } = res;

      // if (!payload.signed) {
      //   onSuccess();
      // } else {
      //   setStorageItem(localStorage, "token", data.result.accessToken, () => {
      //     setDefaultHeader();
      //   });
      // }
      setStorageItem(localStorage, "token", data.result.accessToken, () => {
        setDefaultHeader();
        if (payload.signed) {
          onSuccess();
        }
      });
      yield put({
        type: VERIFY_PHONE_SUCCESS,
        onSuccess,
        token: data.result.accessToken,
      });
    } else {
      yield put({ type: VERIFY_PHONE_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* termsAndCondition({ payload }) {
  const { token, onSuccess } = payload;
  setBearerToken(token);
  yield put({ type: TERMS_AND_CONDITION_INIT });
  try {
    const res = yield postUtil(`${API.TermsAndCondition}`);
    if (res?.status === 200) {
      const { data } = res;
      setStorageItem(localStorage, "token", data.result.accessToken, () => {
        setDefaultHeader();
        onSuccess();
      });
      yield put({ type: TERMS_AND_CONDITION_SUCCESS, onSuccess });
    } else {
      yield put({ type: TERMS_AND_CONDITION_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* sendVerficationCode({ payload }) {
  const { is2FA, userId } = payload;

  yield put({ type: SEND_TWO_FA_CODE_INIT });
  try {
    const res = yield postUtil(
      (is2FA ? API.SendTwoFactorCodeUrl : API.SendVerifyPhoneNumberUrl) +
        "?userId=" +
        userId
    );
    if (res?.status === 200) {
      yield put({ type: SEND_TWO_FA_CODE_SUCCESS });
    } else {
      yield put({ type: SEND_TWO_FA_CODE_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}

export function* sendVerficationCodeToEmail({ payload }) {
  const { userId } = payload;

  yield put({ type: SEND_TWO_FA_CODE_TO_EMAIL_INIT });
  try {
    const res = yield postUtil(`${API.SendTwoFactorCodeToEmailUrl}?userId=${userId}`);
    if (res?.status === 200) {
      yield put({ type: SEND_TWO_FA_CODE_TO_EMAIL_SUCCESS });
    } else {
      yield put({ type: SEND_TWO_FA_CODE_TO_EMAIL_FAILED });
    }
  } catch (error) {
    throw new Error(error);
  }
}


export function* login() {
  yield takeLatest(LOGIN, loginCall);
  yield takeLatest(TWO_FACTOR_AUTH, twoFactor);
  yield takeLatest(VERIFY_PHONE, verifyPhone);
  yield takeLatest(TERMS_AND_CONDITION, termsAndCondition);
  yield takeLatest(SEND_TWO_FA_CODE, sendVerficationCode);
  yield takeLatest(SEND_TWO_FA_CODE_TO_EMAIL, sendVerficationCodeToEmail);
}
